<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-22                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <b-button-toolbar class="justify-content-center my-3">
      <b-button-group class="mr-3">
        <b-button variant="danger" :disabled="addToQuoteDisabled" @click="saveProduct"> Add To Quote</b-button>
      </b-button-group>
      <b-button-group>
        <b-button variant="link" @click="goBack"> Cancel</b-button>
      </b-button-group>
    </b-button-toolbar>
    <similar-products-dialog ref="similar_products_dialog"
                             :quote-product="quoteProduct"
                             @proceed-with-bto="proceedWithBTO"
                             @cancelled="handleSimilarProductsCancelled">
    </similar-products-dialog>
  </div>
</template>

<script>
import QuoteProduct from "../../business-objects/quote-product";
import SimilarProductsDialog from "./similar-products-dialog.vue";

export default {
  name: "configuration-dialog-buttons",
  components: {
    SimilarProductsDialog
  },
  props: {
    quoteProduct: {
      type: QuoteProduct,
      required: true
    },
    isPublic:{
      type: Boolean,
      required: true
    },
    isBto:{
      type: Boolean,
      default: false
    },
    isLoading:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSelectedItems() {
      return this.quoteProduct.cfg_item_ids && this.quoteProduct.cfg_item_ids.length > 0;
    },
    addToQuoteDisabled() {
      return this.isBto && (this.isLoading || !this.hasSelectedItems);
    }
  },
  methods: {
    saveProduct() {
      if (this.addToQuoteDisabled) {
        return;
      }
      if(this.isPublic){
        this.savePublicProduct();
      }else{
        let toBeConfirmed = false;
        if(this.isBto && this.quoteProduct.name === 'TBD'){
          toBeConfirmed = true;
        }
        if(toBeConfirmed && !confirm('This sku does not have a p#. It may take up to 12 hours for a part# to be assigned. Do you want to proceed ?')){
          return;
        }
        this.checkSimilarProducts();
      }

    },
    goBack(){
      this.$router.go(-1);
    },
    savePublicProduct(){
      this.$store
          .dispatch('PublicQuoteProductsStore/create', {
            cfg_template_version_id: this.quoteProduct.cfg_template_version_id,
            cfg_item_ids: this.quoteProduct.cfg_item_ids
          })
          .then((savedItem) => {
            this.$router.push({name: 'quote_path'});
          })
          .catch((error) => {
            alert(error.response ? error.response.data : error);
          });
    },
    saveOtherProduct(){
      this.$store
          .dispatch('QuoteProductsStore/create', {
            quote_part_id: this.$route.params.quote_part_id,
            cfg_template_version_id: this.quoteProduct.cfg_template_version_id,
            cfg_item_ids: this.quoteProduct.cfg_item_ids,
            attributes_string:this.quoteProduct.attributes_string,
            details_attributes_string: this.quoteProduct.detail_attributes_string
          })
          .then((savedItem) => {
            this.$router.push({name: 'quote_path'});
          })
          .catch((error) => {
            alert(error.response ? error.response.data : error);
          });
    },
    checkSimilarProducts() {
      if (!this.isBto) {
        this.saveOtherProduct();
        return;
      }
      if (!this.hasSelectedItems) {
        return;
      }

      let macro_query = {
        id: 'dynabook_find_similar_non_bto',
        cfg_template_version_id: this.quoteProduct.cfg_template_version_id,
        cfg_item_ids: this.quoteProduct.cfg_item_ids
      };

      this.$store.dispatch('MacroResultsStore/execute', macro_query)
        .then((result) => {
          if (result && result.length > 0) {
            this.$refs.similar_products_dialog.show(result);
          } else {
            this.saveOtherProduct();
          }
        })
        .catch((error) => {
          console.log('Error checking similar products:', error);
          alert(error)
          //this.saveOtherProduct();
        });
    },
    proceedWithBTO() {
      this.saveOtherProduct();
    },
    handleSimilarProductsCancelled() {
    }
  }
}
</script>

<style scoped>

</style>
